import { useCallback } from 'react';
import { SessionType } from 'models/Message';
import { getUserFullName } from 'utils';

export default function useMessageRepresented() {
  return useCallback((session: SessionType) => {
    const {
      interlocutor,
      deal,
      isRepresentingSellSide,
      sellRepresentative,
      buyRepresentatives,
      isGroupChat,
      groupName,
    } = session || {};

    // Direct Message
    const interlocutorFullName = getUserFullName(
      interlocutor?.firstName,
      interlocutor?.lastName,
    );

    // Deal message
    const dealName =
      deal?.portfolioName || deal?.listing?.listingTitle || deal?.name;

    const dealLogo = deal?.listing?.gallery?.[0]?.url;

    const representerName = !isRepresentingSellSide
      ? sellRepresentative?.companyName
      : isGroupChat
      ? groupName
      : getUserFullName(
          buyRepresentatives?.[0]?.firstName,
          buyRepresentatives?.[0]?.lastName,
        );

    const representerLogo = !isRepresentingSellSide
      ? sellRepresentative?.companyLogo?.url
      : isGroupChat
      ? null
      : buyRepresentatives?.[0]?.profileImage?.url;

    return {
      interlocutorFullName,
      dealName,
      dealLogo,
      representerName,
      representerLogo,
    };
  }, []);
}
